import { Sport } from '__generated__/globalTypes';

import { Ball } from './Ball';
import { MLBBall } from './MLBBall';
import { NBABall } from './NBABall';

type Props = { sport: Sport; size?: number };

export const SportBall = ({ sport, size }: Props) => {
  return {
    [Sport.FOOTBALL]: <Ball width={size} />,
    [Sport.NBA]: <NBABall size={size} />,
    [Sport.BASEBALL]: <MLBBall width={size} />,
  }[sport];
};
